import Vue from 'vue'
import Cookies from 'js-cookie'
import { REGION_ID_SET } from '../store/modules/website/mutation-types'
import { SET_SELECTED_REGIONS } from '../store/modules/selection/mutation-types'

const getWebsiteRegionId = function () {
  return Cookies.get(Vue.prototype.$container.config.arrivaXcCookieNameCurrentRegionId)
}

const overrideFromWebsiteCookie = async function () {
  let overridden = false
  const websiteRegionId = getWebsiteRegionId()
  // if the website region is set and changed, update the criteria
  if (websiteRegionId && websiteRegionId !== Vue.prototype.$container.store.state.website.regionId) {
    await Vue.prototype.$container.store.dispatch('selection/fetchRegions')
    Vue.prototype.$container.store.commit('website/' + REGION_ID_SET, websiteRegionId)
    const region = Vue.prototype.$container.store.getters['selection/findRegionByCookieId'](websiteRegionId)
    const regions = region ? [region] : []
    Vue.prototype.$container.store.commit('selection/' + SET_SELECTED_REGIONS, regions)
    overridden = true
  }
  return overridden
}

export {
  overrideFromWebsiteCookie
}



// WEBPACK FOOTER //
// ./src/website-integration/region-manager.js